import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitofivejyotilingadarshancab() {



const cardData = {
  keyword: "Mumbai to 5 Jyotirlinga Darshan Cab",
  heading: "Lotus Cab: Mumbai to 5 Jyotirlinga Darshan Cab",

headingDescription:
    "Lotus Cabs offers reliable and affordable Mumbai to 5 Jyotirlinga Darshan Cab services for devotees seeking a comfortable and spiritually enriching pilgrimage across Maharashtra. Whether you are planning a family pilgrimage, senior citizen yatra, religious group tour, or a customized temple itinerary, we provide Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional chauffeurs experienced on all major pilgrimage routes. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Mumbai, flexible travel schedules, well-maintained vehicles, and safe long-distance journeys, Lotus Cabs ensures a peaceful, convenient, and memorable 5 Jyotirlinga Darshan experience from Mumbai.",

  top: "Top Places to Visit in 5 Jyotirlinga with Lotus Cab",

 topPlaces: [
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar Jyotirlinga, nestled in the lush Sahyadri Hills of Maharashtra, is one of the twelve sacred Jyotirlingas of Lord Shiva and an important stop on the 5 Jyotirlinga Darshan circuit. The ancient temple is surrounded by dense forests and the Bhimashankar Wildlife Sanctuary, offering devotees a peaceful spiritual atmosphere along with breathtaking natural beauty. Pilgrims from Mumbai visit throughout the year to perform darshan, Rudrabhishek, and other sacred rituals."
    },
    {
        title: "Trimbakeshwar Jyotirlinga",
        description:
            "Located near Nashik at the foothills of Brahmagiri Hills, Trimbakeshwar Jyotirlinga is one of India's most revered Shiva temples. It is famous for its unique three-faced Jyotirlinga, the sacred Kushavarta Kund, and special rituals including Narayan Nagbali and Kalsarp Dosh Puja. Thousands of devotees from Mumbai include this holy shrine as an essential part of their Jyotirlinga pilgrimage."
    },
    {
        title: "Grishneshwar Jyotirlinga",
        description:
            "Grishneshwar Jyotirlinga, situated near the UNESCO World Heritage Site of Ellora Caves in Chhatrapati Sambhajinagar, is the twelfth and final Jyotirlinga. The temple is admired for its magnificent Hemadpanti architecture, intricate carvings, and profound religious significance. Pilgrims often combine their visit with nearby historical attractions for a spiritually and culturally enriching journey."
    },
    {
        title: "Aundha Nagnath Jyotirlinga",
        description:
            "Aundha Nagnath Jyotirlinga in Hingoli district is considered by many devotees to be one of the oldest Jyotirlinga temples in India. The temple's ancient stone architecture, peaceful surroundings, and centuries-old traditions attract pilgrims seeking Lord Shiva's blessings. It remains a key destination on the Maharashtra Jyotirlinga pilgrimage route."
    },
    {
        title: "Parli Vaijnath Jyotirlinga",
        description:
            "Parli Vaijnath Jyotirlinga, located in Beed district, completes the sacred 5 Jyotirlinga Darshan circuit of Maharashtra. Known for its beautiful temple architecture, spiritual importance, and traditional religious ceremonies, the temple welcomes thousands of devotees every year who seek divine blessings, peace, and prosperity."
    },
    {
        title: "Ellora Caves",
        description:
            "Situated just a short distance from Grishneshwar Jyotirlinga, Ellora Caves are among India's greatest archaeological treasures and a UNESCO World Heritage Site. The magnificent rock-cut caves feature Hindu, Buddhist, and Jain monuments, including the world-famous Kailasa Temple, making this destination a remarkable blend of spirituality, history, and architectural excellence."
    },
    {
        title: "Shani Shingnapur",
        description:
            "Shani Shingnapur is one of Maharashtra's most famous pilgrimage destinations dedicated to Lord Shani and is commonly included in the 5 Jyotirlinga Darshan itinerary from Mumbai. The village is renowned for its unique tradition of houses without doors and attracts devotees seeking protection, prosperity, and relief from planetary doshas."
    },
    {
        title: "Panchavati, Nashik",
        description:
            "Panchavati is one of the holiest places in Nashik and is closely associated with the Ramayana. Pilgrims visiting Trimbakeshwar often extend their journey to explore Ram Kund, Kalaram Temple, Sita Gufa, and the sacred Godavari Ghats, adding greater religious significance to their pilgrimage."
    },
    {
        title: "Bibi Ka Maqbara",
        description:
            "Located in Chhatrapati Sambhajinagar, Bibi Ka Maqbara is one of Maharashtra's finest Mughal-era monuments and is popularly known as the 'Mini Taj Mahal.' Pilgrims and tourists frequently visit this architectural masterpiece while traveling to Grishneshwar Jyotirlinga and Ellora Caves, making it an excellent addition to the pilgrimage itinerary."
    },
    {
        title: "Daulatabad Fort",
        description:
            "Daulatabad Fort is one of India's most impressive medieval hill forts, renowned for its extraordinary defense system, historic gateways, secret passages, and panoramic hilltop views. Situated near Ellora and Grishneshwar, the fort offers travelers an opportunity to experience Maharashtra's rich history alongside their sacred 5 Jyotirlinga Darshan journey."
    }
],

  services: [
    {
      name: "Mumbai to 5 Jyotirlinga Cab",
      description:
        "Comprehensive pilgrimage cab service covering all 5 Jyotirlinga temples in Maharashtra. Ideal for multi-day spiritual tours. AC sedans, SUVs, and mini buses available. Professional chauffeurs experienced in temple routes. Transparent pricing structure. Safe interstate highway travel guaranteed."
    },
    {
      name: "One Way Cab Mumbai to 5 Jyotirlinga",
      description:
        "Affordable one-way cab option for pilgrims planning extended temple stays. Pay only for one-side distance. Flexible drop options available."
    },
    {
      name: "Round Trip Cab Mumbai to 5 Jyotirlinga",
      description:
        "Complete round-trip pilgrimage package with return scheduling convenience. Ideal for families and elderly travelers."
    },
    {
      name: "SUV Cab Mumbai to 5 Jyotirlinga",
      description:
        "Spacious SUV vehicles perfect for group temple tours and luggage comfort. Stable ghat road performance ensured."
    },
    {
      name: "Luxury Cab Mumbai to 5 Jyotirlinga",
      description:
        "Premium luxury vehicles for comfortable and exclusive pilgrimage travel."
    },
    {
      name: "Mini Bus Mumbai to 5 Jyotirlinga",
      description:
        "Mini bus service for large family groups and temple tour batches."
    },
    {
      name: "Chauffeur Driven Cab Mumbai to 5 Jyotirlinga",
      description:
        "Professional drivers trained for long-distance spiritual routes ensure safe travel."
    },
    {
      name: "Online Cab Booking Mumbai to 5 Jyotirlinga",
      description:
        "Instant booking with transparent fare breakdown and quick confirmation."
    }
  ],

  tableData: [
    ["Mumbai to 5 Jyotirlinga Cab", "One Way Cab Mumbai to 5 Jyotirlinga"],
    ["Round Trip Cab Mumbai to 5 Jyotirlinga", "AC Cab Mumbai to 5 Jyotirlinga"],
    ["Sedan Cab Mumbai to 5 Jyotirlinga", "SUV Cab Mumbai to 5 Jyotirlinga"],
    ["Luxury Cab Mumbai to 5 Jyotirlinga", "Family Trip Cab Mumbai to 5 Jyotirlinga"],
    ["Corporate Cab Mumbai to 5 Jyotirlinga", "Weekend Trip Cab Mumbai to 5 Jyotirlinga"],
    ["Mini Bus Mumbai to 5 Jyotirlinga", "Chauffeur Driven Cab Mumbai to 5 Jyotirlinga"],
    ["Budget Cab Mumbai to 5 Jyotirlinga", "Same Day Return Cab Mumbai to 5 Jyotirlinga"],
    ["Outstation Taxi Mumbai to 5 Jyotirlinga", "Per Km Rate Cab Mumbai to 5 Jyotirlinga"],
    ["Best Cab Service Mumbai to 5 Jyotirlinga", "Group Tour Cab Mumbai to 5 Jyotirlinga"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Complete 5 Temple Coverage",
      WhyChoosedescription:
        "We cover all 5 Jyotirlinga temples with planned route management for smooth pilgrimage travel."
    },
    {
      WhyChooseheading: "Safe Ghat Road Driving",
      WhyChoosedescription:
        "Experienced drivers ensure safe navigation through hilly temple routes."
    },
    {
      WhyChooseheading: "Comfortable Long-Distance Travel",
      WhyChoosedescription:
        "AC sedans, SUVs, and mini buses designed for fatigue-free journeys."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear per-kilometer rates without hidden charges."
    },
    {
      WhyChooseheading: "Senior-Friendly Travel",
      WhyChoosedescription:
        "Spacious seating and smooth suspension ideal for elderly pilgrims."
    },
    {
      WhyChooseheading: "Multi-Day Tour Packages",
      WhyChoosedescription:
        "Flexible itinerary planning for 2–3 day pilgrimage trips."
    },
    {
      WhyChooseheading: "24/7 Customer Assistance",
      WhyChoosedescription:
        "Dedicated support for booking and travel coordination."
    },
    {
      WhyChooseheading: "Reliable & Punctual Service",
      WhyChoosedescription:
        "On-time pickup and safe return guaranteed."
    }
  ]
};



const faqData = [
  {
    question: "How many days are required for 5 Jyotirlinga Darshan?",
    answer: "Typically 2 to 3 days are recommended to comfortably cover all five Jyotirlinga temples with proper darshan time and rest."
  },
  {
    question: "Are SUVs recommended for this trip?",
    answer: "Yes, SUVs are ideal for ghat roads and group travel comfort."
  },
  {
    question: "Is round-trip booking available?",
    answer: "Yes, flexible round-trip pilgrimage packages are available."
  },
  {
    question: "Are drivers familiar with temple routes?",
    answer: "Yes, our chauffeurs are experienced in Maharashtra pilgrimage routes."
  },
  {
    question: "Is pricing per km transparent?",
    answer: "Yes, we provide clear per-kilometer fare details before confirmation."
  },
  {
    question: "Are mini buses available?",
    answer: "Yes, mini buses are available for large family groups and temple tours."
  },
  {
    question: "Is online booking available?",
    answer: "Yes, instant online booking with confirmation is available."
  },
  {
    question: "Are vehicles sanitized?",
    answer: "Yes, all vehicles are regularly cleaned and sanitized."
  },
  {
    question: "Is same-day return possible?",
    answer: "Yes, depending on temple coverage and travel schedule."
  },
  {
    question: "Is 24/7 support available?",
    answer: "Yes, our support team is available round-the-clock."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Kulkarni",
    feedback:
      "We booked a 3-day 5 Jyotirlinga tour from Mumbai. The SUV was extremely comfortable and driver was very knowledgeable about temple routes. Excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anita Sharma",
    feedback:
      "Safe and smooth pilgrimage trip with elderly parents. Very punctual and respectful driver. Highly recommended.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Group",
    feedback:
      "Booked mini bus for group darshan tour. Comfortable seating and transparent pricing. Very organized service.",
    rating: 5
  },
  {
    id: 4,
    name: "Family Traveler",
    feedback:
      "Best cab service for Jyotirlinga tour from Mumbai. Clean vehicle and stress-free journey.",
    rating: 5
  }
];
































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to 5 Jyotirlinga Darshan Cab",
"image": "https://lotuscab.com/assets/images/mumbai-to-5-jyotirlinga-darshan-cab.jpg",
"description": "Book Mumbai to 5 Jyotirlinga Darshan Cab with Lotus Cab for a safe, comfortable, and spiritual pilgrimage tour. One way, round trip, and customized taxi packages with Sedan, SUV, and AC cabs available 24x7 with experienced drivers.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7916"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/mumbai-to-5-jyotirlinga-darshan-cab"
}
};














  return (
    <div>
      

<Helmet>
  <title>Mumbai to 5 Jyotirlinga Darshan Cab | Pilgrimage Taxi Package | +91 8767592195</title>

<meta
 name="description"
 content="Book Mumbai to 5 Jyotirlinga Darshan Cab with Lotus Cab for a spiritual tour covering Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Affordable pilgrimage taxi packages with AC cabs and experienced drivers."
/>

<meta
 name="keywords"
 content="Mumbai to 5 Jyotirlinga Darshan Cab, Mumbai 5 Jyotirlinga Tour Package, Jyotirlinga Cab from Mumbai, Mumbai to Bhimashankar Cab, Mumbai to Trimbakeshwar Cab, Mumbai to Grishneshwar Cab, Mumbai to Aundha Nagnath Cab, Mumbai to Parli Vaijnath Cab, Maharashtra Jyotirlinga Cab Service, Pilgrimage Cab Mumbai, 5 Jyotirlinga Taxi Mumbai, Outstation Spiritual Cab Mumbai, Best Jyotirlinga Cab Service Mumbai, Lotus Cab Mumbai Jyotirlinga"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/67.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitofivejyotilingadarshancab;